import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Spinner,
} from 'reactstrap';
import classnames from 'classnames';
import RequestHpsMarket from './RequestHpsMarket';
import InviteDmut from './InviteDmut';
import InvitePanitiaTender from './InvitePanitiaTender';
import RequestFreightAvailability from './RequestFreightAvailability';
import useProcurementDetail from '../../hooks/useProcurementDetail';
import useProcurementDocuments from '../../hooks/useProcurementDocuments';
import { useQuantityDeliveries } from '../../../../Components/QuantityTable';
import {
  displayValue,
  formatSubmittedDate,
  getTenderOpeningStatusConfig,
  getTenderOpeningTabCompletion,
} from '../../utils/tenderOpeningHelpers';

const DETAIL_TABS = [
  {
    id: 'request-hps',
    label: 'Request HPS Market',
    icon: 'ri-file-list-3-line',
    component: RequestHpsMarket,
    completionKey: 'isRequestHpsCompleted',
  },
  {
    id: 'invite-dmut',
    label: 'Invite DMUT',
    icon: 'ri-mail-send-line',
    component: InviteDmut,
    completionKey: 'isInviteDMUTCompleted',
  },
  {
    id: 'invite-panitia',
    label: 'Invite Panitia Tender',
    icon: 'ri-group-line',
    component: InvitePanitiaTender,
    completionKey: 'isInvitePanitiaTenderCompleted',
  },
  {
    id: 'req-freight',
    label: 'Request Freight Availability',
    icon: 'ri-ship-line',
    component: RequestFreightAvailability,
    completionKey: 'isReqFreightAvailabilityCompleted',
  },
];

const TenderOpeningTabStatusIcon = ({ completionFlag }) => {
  if (completionFlag === true) {
    return (
      <i
        className='ri-checkbox-circle-fill text-success ms-1 align-middle'
        title='Done'
        aria-label='Done'
      />
    );
  }

  if (completionFlag === false) {
    return (
      // <i
      //   className='ri-error-warning-fill text-warning ms-1 align-middle'
      //   title='In Progress'
      //   aria-label='In Progress'
      // />
      <i
        className='ri-error-warning-fill text-warning ms-1 align-middle fs-18'
        title='Open'
        aria-label='Open'
      />
    );
  }

  return (
    <i
      className='ri-checkbox-blank-circle-fill text-secondary ms-1 align-middle'
      title='Open'
      aria-label='Open'
    />
  );
};

const DetailProductHydro = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('request-hps');
  const { procurement, isLoading, refresh } = useProcurementDetail(id);
  const { documents: procurementDocuments, isLoading: isLoadingDocuments } =
    useProcurementDocuments(id);
  const { parcels, isLoading: isLoadingParcels } = useQuantityDeliveries(id);

  useEffect(() => () => toast.dismiss(), []);

  const visibleTabs = DETAIL_TABS.filter(tab => {
    if (tab.id === 'req-freight')
      return procurement?.isReqFreightAvailabilityEnable;
    return true;
  });

  const statusConfig = getTenderOpeningStatusConfig(
    procurement?.tenderOpeningStatus
  );
  const categoryLabel =
    procurement?.procurementTypeHeaderLabel || 'Product Hydro';

  return (
    <div className='page-content'>
      <ToastContainer closeButton={false} />
      <Container fluid>
        <div className='email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
          <div className='email-content minimal-border'>
            <div className='p-4 pb-0'>
              <div className='border-bottom border-bottom-dashed'>
                <Row className='mt-n2 mb-1 mb-sm-0'>
                  <div className='col-sm order-3 order-sm-2'>
                    <div className='hstack gap-sm-1 align-items-center flex-wrap email-topbar-link'>
                      <h5 className='card-title mb-0 flex-grow-1'>
                        <Breadcrumb listClassName='p-3 py-2 bg-light'>
                          <BreadcrumbItem>
                            <Link to='/dashboard'>Home</Link>
                          </BreadcrumbItem>
                          <BreadcrumbItem>
                            <Link to='/apps-tenderopening/view'>
                              Tender Opening
                            </Link>
                          </BreadcrumbItem>
                          <BreadcrumbItem active>
                            Detail #
                            {displayValue(procurement?.procurementNumber)}
                          </BreadcrumbItem>
                        </Breadcrumb>
                      </h5>
                    </div>
                  </div>
                </Row>

                <Row className='mb-4'>
                  <Col xs={12}>
                    <Row className='align-items-center g-3'>
                      <Col xs={12} lg>
                        <div className='d-flex align-items-start gap-3'>
                          <Button
                            color='light'
                            className='border shadow-sm rounded-circle d-flex align-items-center justify-content-center p-0'
                            style={{ width: '2.5rem', height: '2.5rem' }}
                            onClick={() => navigate('/apps-tenderopening/view')}
                          >
                            <i className='bx bx-arrow-back fs-5 text-dark'></i>
                          </Button>
                          <div className='flex-grow-1'>
                            {isLoading && !procurement ? (
                              <div className='d-flex align-items-center gap-2 py-2'>
                                <Spinner size='sm' color='primary' />
                                <span className='text-muted small'>
                                  Loading procurement...
                                </span>
                              </div>
                            ) : (
                              <>
                                <h4 className='mb-1 fw-bold text-dark'>
                                  {categoryLabel} —{' '}
                                  {displayValue(procurement?.titleProcurement)}
                                </h4>
                                <div className='d-flex flex-wrap align-items-center gap-2 text-muted small'>
                                  <i className='bx bx-hash'></i>
                                  <span>
                                    Procurement ID:{' '}
                                    {displayValue(
                                      procurement?.procurementNumber
                                    )}
                                  </span>

                                  <span className='d-none d-md-inline text-secondary opacity-25'>
                                    |
                                  </span>

                                  <i className='bx bx-calendar'></i>
                                  <span>
                                    {formatSubmittedDate(
                                      procurement?.submittedDateTenderOpening
                                    )}
                                  </span>

                                  <span
                                    className={`badge ${statusConfig.className} fw-semibold px-3 py-1 rounded-pill`}
                                  >
                                    {statusConfig.label}
                                  </span>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <hr className='mt-3 mb-0 border-secondary opacity-10' />
                  </Col>
                </Row>
              </div>

              <Card className='border-0 shadow-sm'>
                <CardBody className='p-0'>
                  <Nav tabs className='nav-tabs-custom nav-primary px-3 pt-3'>
                    {visibleTabs.map(tab => {
                      const completionFlag = getTenderOpeningTabCompletion(
                        procurement,
                        tab.completionKey
                      );

                      return (
                        <NavItem key={tab.id}>
                          <NavLink
                            className={classnames('cursor-pointer', {
                              active: activeTab === tab.id,
                            })}
                            onClick={() => setActiveTab(tab.id)}
                          >
                            <i className={`${tab.icon} align-middle me-1`}></i>
                            <span className='fw-semibold d-inline-flex align-items-center'>
                              {tab.label}
                              {procurement && (
                                <TenderOpeningTabStatusIcon
                                  completionFlag={completionFlag}
                                />
                              )}
                            </span>
                          </NavLink>
                        </NavItem>
                      );
                    })}
                  </Nav>

                  <TabContent activeTab={activeTab} className='p-4'>
                    {visibleTabs.map(tab => {
                      if (activeTab !== tab.id) return null;

                      const TabComponent = tab.component;
                      const sharedProps = {
                        procId: id,
                        procurement,
                        isLoadingProcurement: isLoading,
                        onRefreshProcurement: refresh,
                        parcels,
                        isLoadingParcels,
                      };
                      const inviteProps = {
                        procurementDocuments,
                        isLoadingDocuments,
                      };

                      return (
                        <TabPane key={tab.id} tabId={tab.id}>
                          <TabComponent
                            {...sharedProps}
                            {...(tab.id === 'invite-dmut' ||
                            tab.id === 'invite-panitia'
                              ? inviteProps
                              : {})}
                          />
                        </TabPane>
                      );
                    })}
                  </TabContent>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default DetailProductHydro;
